import { useCurrentProjectContext } from "@v2/contexts/CurrentProjectContext";
import useDefaultV2CustomDomain from "@v2/features/page-settings/useDefaultCustomDomain";

/**
 * Hook to get the shop's domain for display purposes.
 * Returns the custom domain if available, otherwise the shop domain prefix.
 */
const useShopDomain = () => {
  const { project } = useCurrentProjectContext();
  const defaultCustomDomain = useDefaultV2CustomDomain();

  if (defaultCustomDomain?.value) {
    return defaultCustomDomain.value;
  }

  if (project?.shopDomainPrefix) {
    return `${project.shopDomainPrefix}.reploshops.com`;
  }

  return "your-store.reploshops.com";
};

export default useShopDomain;
